import { Dispatch } from "redux";
import {
  ClearAllFlashMessages,
  FlashMessagesActionTypes,
  FlashMessageType,
  RemoveFlashMessage,
  RemoveFlashMessagesByType,
  ShowFlashMessage,
} from "../types/flash-messages-types";

/**
 * Displays new flash message.
 * @param flashMessage Flash message to display
 */
export const showFlashMessage = (
  message: string,
  type: FlashMessageType,
  id?: number,
): ShowFlashMessage => ({
  type: FlashMessagesActionTypes.SHOW_FLASH_MESSAGE,
  payload: {
    id,
    message,
    type,
  },
});

/**
 * Removes displayed flash message.
 * @param flashMessageId id of flash message to remove
 */
export const removeFlashMessage = (
  flashMessageId: number,
): RemoveFlashMessage => ({
  type: FlashMessagesActionTypes.REMOVE_FLASH_MESSAGE,
  payload: {
    flashMessageId,
  },
});

/**
 * Removes all flash messages of specific type.
 * @param messageType type of flash messages to remove
 */
export const removeFlashMessagesByType = (
  messageType: FlashMessageType,
): RemoveFlashMessagesByType => ({
  type: FlashMessagesActionTypes.REMOVE_FLASH_MESSAGES_BY_TYPE,
  payload: {
    messageType,
  },
});

/**
 * Removes all flash messages.
 */
export const clearAllFlashMessages = (): ClearAllFlashMessages => ({
  type: FlashMessagesActionTypes.CLEAR_ALL_FLASH_MESSAGES,
});

/**
 *
 * @param dispatch is Dispatch from redux
 * @param message string for flash message
 * @param type type for flash message
 * @param timeout number in ms, if not provided default is 5000
 * @param clearExistingOfSameType if true, removes existing messages of the same type before adding new one
 */
export const showFlashMessageWithTimeout = (
  dispatch: Dispatch,
  message: string,
  type: FlashMessageType,
  timeout?: number,
  clearExistingOfSameType?: boolean,
): void => {
  // If clearExistingOfSameType is true, first clear existing messages of same type
  if (clearExistingOfSameType) {
    dispatch(removeFlashMessagesByType(type));
  }
  
  const simpleId = Date.now();
  dispatch(showFlashMessage(message, type, simpleId));
  setTimeout(
    () => {
      dispatch(removeFlashMessage(simpleId));
    },
    timeout ? timeout : 5000,
  );
};
